export default __webpack_public_path__ + "static/media/close.9a5ebe16.svg";